import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {RoutingService} from '../../service/routing/routingService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {attachWorkspaceFilterState} from '../../utils/workspaceStateUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class PostalCodeGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
								
		var postalGrid = this;
		setTimeout(function(){
			postalGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var postalGrid = this;

		
		var toolbarFilter = ElementUtil.create({
			tag: 'dl-toolbar',
		'collapse-label': 'Filter',
			slot: 'toolbar',
			theme: 'spacing',			
			children: [				
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterCountry',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;',
					label: 'Country',
					'item-value-path': 'code',
					'item-label-path': 'description',					
					postinit: function(combo) {
						Service.getLookupService().getLookupValues('CountryCode').then(function(data){
							combo.items = data;
						});
					},
					placeHolder: 'Select',
					listeners: {
						change: function() {
							actionRefresh();
						}
					}
				},
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterState',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;',
					label: 'State/Prov',
					'item-value-path': 'code',
					'item-label-path': 'description',				
					postinit: function(combo) {
						Service.getLookupService().getLookupValues('StateProvCode').then(function(data){
							combo.items = data;
						});
					},
					placeHolder: 'Select',
					listeners: {
						change: function() {
							actionRefresh();
						}
					}					
				},
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterType',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;',
					label: 'Filter By',
					'item-value-path': 'code',
					'item-label-path': 'description',
					required: true,
					value: 'postalCodeCityId.cityName',
					postinit: function(combo) {						
						var lookups = [
							{
								code: 'postalCodeCityId.cityName',
								description: 'City Name'								
							},
							{
								code: 'postalCodeCityId.postalCode',
								description: 'Postal Code'	
							}
						];
						combo.items = lookups;						
					},
					placeHolder: 'Select'					
				},				
				{
					tag: 'vaadin-text-field',
					itemid: 'filterValue',
					'class': 'spacer-toolbar-item',
					'keep-open': true,
					label: 'Filter Value',
					listeners: {
						input: {
							fn: function() {
								actionRefresh();
							},
							buffer: 2000
					    }
					}
				}
			]
		});
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',					
					permissions: ['ADMIN_POSTAL_CODE_CITIES:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')						
					],
					listeners: {
						click: function() {
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['ADMIN_POSTAL_CODE_CITIES:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')						
					],
					listeners: {
						click: function() {
							actionAddEdit(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'delete',
					theme: 'error primary',	
					style: 'float: right;',
					permissions: ['ADMIN_POSTAL_CODE_CITIES:DELETE'],
					'class': 'spacer-toolbar-item',
					disabled: true,
					children:[
						ElementUtil.makeIcon('vaadin:trash', ' Delete')
					],
					listeners: {
						click: function() {
							actionDelete(grid.selectedItems[0]);
						}
					}
				}				
			]
		});		
		
		var toolbarContainer = ElementUtil.create({
			tag: 'div',
			slot: 'toolbar',
			children: [
				toolbarFilter,
				ElementUtil.create({
					tag: 'hr'
				}),
				toolbar
			]
		});		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [
				{						
					path: 'postalCodeCityId.countryCode',
					header: 'Country Code',
					width: '7em'
				},	
				{						
					path: 'postalCodeCityId.stateProvCode',
					header: 'State Prov',
					width: '7em'
				},
				{						
					path: 'postalCodeCityId.cityName',
					header: 'City Name',
					width: '7em'
				},
				{						
					path: 'postalCodeCityId.postalCode',
					header: 'Postal Code',
					width: '7em'
				},
				{						
					path: 'cityLat',
					header: 'Latitude',
					width: '7em'
				},
				{						
					path: 'cityLong',
					header: 'Longitude',
					width: '7em'
				}				
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					
					if (grid.selectedItems.length > 0) {					  
						ElementUtil.query(toolbar, 'edit').disabled = false;
						ElementUtil.query(toolbar, 'delete').disabled = false; 						
					} else {						
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'delete').disabled = true; 						
					}
				}
			}
		});	
			
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 50,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
										
					var loadData = function() {
												
						grid.currentFilter = {
							offset: pageRange.offset,
							max: pageRange.max,
							sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'updateDts',
							sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC',
							state: ElementUtil.query(toolbarFilter, 'filterState').value,
							country: ElementUtil.query(toolbarFilter, 'filterCountry').value,
							filterField: ElementUtil.query(toolbarFilter, 'filterType').value,
							filterValue: ElementUtil.query(toolbarFilter, 'filterValue').value
						};
						
						var successHandler = function(records) {
							loadMask.remove();
							grid.activeItem = null;						
							grid.items = records.data;

							pagingToolbar.totalRecords = records.totalNumber;
							pagingToolbar.updatePager();						
						};
						
						RoutingService.getPostalCodeService().getPostalCodes(grid.currentFilter).then(function(records){
							successHandler(records);
						});						
					};	
					
					loadData();
														
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();					
				}
			}
			
		});			
		
		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'primary',
			onDetail: function() {
				var exportFilter = Object.assign({}, grid.currentFilter || {});
				delete exportFilter.offset;
				delete exportFilter.max;
				RoutingService.getPostalCodeService().exportPostalCodes(exportFilter);
			}
		});
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbarContainer,
				grid,
				footer.footerContainer
			]
		});		
		postalGrid.append(flexLayout);		
			
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);	
		};
		attachWorkspaceFilterState(postalGrid, toolbarFilter, ['filterCountry','filterState','filterType','filterValue'], actionRefresh);
				
		var actionAddEdit = function(record) {
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: record ? 'Edit' : 'Add',
				icon: 'vaadin:edit',				
				width: .75,
				height: 325,
				listeners: {
					ready: function() {						
						addEditWin.show();
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [
										{										
											tag: 'vaadin-combo-box',
											itemid: 'country',											
											'keep-open': true,															
											label: 'Country',
											'item-value-path': 'code',
											'item-label-path': 'description',
											name: 'country',
											required: true,
											postinit: function(combo) {
												Service.getLookupService().getLookupValues('CountryCode').then(function(data){
													combo.items = data;
												});
											},
											placeHolder: 'Select',
											listeners: {
												change: function() {
													var countyCB = ElementUtil.query(formPanel, 'country');
													var stateCB = ElementUtil.query(formPanel, 'state');
													Service.getLookupService().getLookupValues('StateProvCode').then(function(data){
														if (countyCB.value) {
															var filtered = [];														
															data.forEach(function(item){
																if (item.country === countyCB.value) {
																	filtered.push(item);
																}
															});
															stateCB.items = filtered;
														} else {
															stateCB.items = [];
														}
													});
												} 
											}
										},
										{										
											tag: 'vaadin-combo-box',
											itemid: 'state',											
											'keep-open': true,															
											label: 'State/Prov',
											'item-value-path': 'code',
											'item-label-path': 'description',
											name: 'state',
											required: true,
											postinit: function(combo) {												
											},
											placeHolder: 'Select'					
										},	
										{
											tag: 'vaadin-text-field',
											itemid: 'cityName',	
											name: 'cityName',
											label: 'City',
											required: true,
											maxLength: 255											
										},
										{
											tag: 'vaadin-text-field',
											itemid: 'postalCode',
											name: 'postalCode',
											label: 'Postal Code',
											required: true,
											maxLength: 20											
										},									
										{
											tag: 'vaadin-number-field',
											name: 'cityLat',
											label: 'City Lat',
											required: true
										},
										{
											tag: 'vaadin-number-field',
											name: 'cityLong',
											label: 'City Long',
											required: true
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
																												
															formPanel.submitForm({
																preSubmit: function(data) {
																	var submitModel = {
																		postalCodeCityId: {
																			countryCode: data.country,
																			stateProvCode: data.state,
																			postalCode: data.postalCode,
																			cityName: data.cityName
																		},
																		cityLat: data.cityLat,
																		cityLong: data.cityLong
																	};
																
																	return submitModel;
																},
																actualCall: function(data) {
																	return RoutingService.getPostalCodeService().savePostalCode(data, (record ? true : false));
																},
																success: function(data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved postal city code', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	actionRefresh();
																	addEditWin.close();
																}
															});															
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						addEditWin.addToContentElement(formPanel);
						
						if (record) {
							var loadRecord = {
								country: record.postalCodeCityId.countryCode,
								state: record.postalCodeCityId.stateProvCode,
								postalCode: record.postalCodeCityId.postalCode,
								cityName: record.postalCodeCityId.cityName,
								cityLat: record.cityLat,
								cityLong: record.cityLong
							};							
							formPanel.load(loadRecord);
							
							var event = new Event('change');
							ElementUtil.query(formPanel, 'country').dispatchEvent(event);
							ElementUtil.query(formPanel, 'country').readonly = true;
							ElementUtil.query(formPanel, 'state').readonly = true;
							ElementUtil.query(formPanel, 'cityName').readonly = true;
							ElementUtil.query(formPanel, 'postalCode').readonly = true;
						}
					}
				}
			});			
		};
		
		var actionDelete = function(record) {
	
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete the selected postal code city record?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing Postal Code...');

							RoutingService.getPostalCodeService().deletePostalCode(record.postalCodeCityId)
							.then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Removed', {									
									theme: 'success'
								});
								actionRefresh();
							})
							.catch(function(){
								loadMask.remove();
							});						
						}
					},
					{
						text: 'No'
					}
				]
			});
					
		};	
				
	}
	
}
customElements.define('dl-postalcode-grid', PostalCodeGrid);